export default "__VITE_ASSET__B8ftH9yf__"